module.exports = __webpack_public_path__ + "img/lxwm1.11fb88a0.png";